<template>
  <div class="myservice">
    <Vueheader :addActive='addActive'></Vueheader>
    <div class="content">
      <div class="search">
        <div class="state">
          <p>当前状态</p>
          <el-select v-model="tjkTaskApplyState" clearable placeholder="请选择" style="width: 170px;">
            <el-option v-for="t in taskOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
          </el-select>
        </div>
        <div class="state">
          <p>客服</p>
          <el-autocomplete class="inline-input" v-model="tjkName" :fetch-suggestions="tjkSearch" placeholder="请输入姓名或登录账号" @select="tjkHandleSelect" :trigger-on-focus="false"></el-autocomplete>
          <button type="button" @click="searchOwnedTjk(1)">查询</button>
        </div>
      </div>
      <div class="contentList">
        <ul style="background:#d1dbe5;">
          <li class="name border">客服姓名</li>
          <li class="phone border">登录账号</li>
          <li class="joinDate border">注册时间</li>
          <li class="currentState border">当前状态</li>
          <li class="workTime border">上岗时长</li>
          <li class="handle">操作</li>
        </ul>
        <ul v-for="(item,key) in serviceList" :class="{'active':key%2 != 1}">
          <li class="name border">{{item.tjkuser.realName}}</li>
          <li class="phone border">{{item.tjkuser.loginName}}</li>
          <li class="joinDate border">{{item.createDate}}</li>
          <li class="currentState border">
            <span v-if="item.tjkStatus == 'WaitTrained'">待培训</span>
            <span v-if="item.tjkStatus == 'Training'">培训中</span>
            <span v-if="item.tjkStatus == 'ForPost'">培训完毕待上岗</span> 
            <span v-if="item.tjkStatus == 'InPost'">已上岗</span>
          </li>
          <li class="workTime border">{{item.workHour}}H</li>
          <li class="handle">
            <a v-if="item.tjkStatus == 'WaitTrained'" class="handle" href="javascript:;" @click="updateTjkStatus(item.tjkuser.id,'Training')">标记开始培训</a>
            <a v-else-if="item.tjkStatus == 'Training'" class="handle" href="javascript:;" @click="updateTjkStatus(item.tjkuser.id,'ForPost')">标记已培训完结</a>
          </li>
        </ul>
        <template>
          <p v-show="serviceList == null || serviceList.length == 0" class="noRecord">暂无记录</p>
        </template>
        <pagination :pages="pages" :pageNum="pageNum" @getData="searchOwnedTjk"></pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import Vueheader from '../components/header'
	export default {
    name: 'myService',
		data(){
			return{
        'addActive': 2,
        'pages': 1,
        'pageNum': 1,
        'pageSize': 10,
        'tjkTaskApplyState': '',
        'taskOptions': [
          {
            label: '全部',
            value: ''
          },
          {
            label: '待培训',
            value: 'WaitTrained'
          },
          {
            label: '培训',
            value: 'Training'
          },
          {
            label: '待上岗',
            value: 'ForPost'
          },{
            label: '上岗',
            value: 'InPost'
          }
        ],
        'tjkUserId': '',
        'tjkName': '',
        'serviceList': [],
        'agentId': this.$route.query.agentId,
        'timer': ''
			}
    },
    watch:{
      tjkName:function() {
        if(this.tjkName == '') {
          this.tjkUserId = ''
        }
      }
    },
		mounted() {
      this.searchOwnedTjk(1)
    },
    components: {
      Vueheader
    },
		methods: {
      //查询代理下的淘金客
      searchOwnedTjk(num) {
        var data = {
          tjkId: this.tjkUserId,
          tjkStatus: this.tjkTaskApplyState,
          page: num?num:this.pageNum,
          pageSize: this.pageSize,
          agentId: this.agentId
        }
        this.$http.post(API_ROOT.system + '/agency/searchOwnedTjk',data).then(response=> {
          var result = response.data
          if(result.success) {
            this.serviceList = result.data.list
            this.pages = result.data.pages
            this.pageNum = result.data.pageNum
          }else {
            this.$message({
              message: result.msg,
              type: 'error',
              center: true,
              duration: 2000
            })
          }
        },response=> {
          this.$message({
            message: '网络繁忙，请稍后重试！',
            type: 'error',
            center: true,
            duration: 2000
          })
        })
      },
      //修改代理下的淘金客
       updateTjkStatus(tjkId,tjkStatus) {
        var data = {
          tjkId: tjkId,
          tjkStatus: tjkStatus,
          agentId: this.agentId
        }
        this.$http.post(API_ROOT.system + '/agency/updateTjkStatus',data).then(response=> {
          var result = response.data
          if(result.success) {
            this.$message({
              message: '修改成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            this.searchOwnedTjk(1)
          }else {
            this.$message({
              message: result.msg,
              type: 'error',
              center: true,
              duration: 2000
            })
          }
        },response=> {
          this.$message({
            message: '网络繁忙，请稍后重试！',
            type: 'error',
            center: true,
            duration: 2000
          })
        })
      },
      //查询淘金客用户
      tjkSearch(queryString, callback) {
        if((queryString !== '') && (queryString.length >= 2)) {
          clearTimeout(this.timer)
          var self = this
          this.timer = setTimeout(function() {
            var tjkList = []
            var data = {
              phoneNumber: queryString,
              page: 1,
              pageSize: self.pageSize
            }
            self.$http.post(API_ROOT.system + '/agency/ownedTjkInfo', data).then(response => {
              var result = response.data
              if(result.success) {
                self.success = result.success
                self.message = result.msg
                //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
                for(let i of result.data.list) {
                  i.value = i.realName+'('+i.loginName+')'
                }
                tjkList = result.data.list
                callback(tjkList)
              }else {
                self.$message({
                  message: result.msg,
                  type: 'error',
                  center: true,
                  duration: 2000
                })
              }
            }, response => {
              self.$message({
                message: '网络繁忙，请稍后重试！',
                type: 'error',
                center: true,
                duration: 2000
              })
            })
          },400)
        }else {
           clearTimeout(this.timer)
        }
      },
      tjkHandleSelect(item) {
        this.tjkUserId = item.id
      },
    }
	}
</script>



// WEBPACK FOOTER //
// myService.vue?69969679